module.exports = __webpack_public_path__ + "img/new-logo-aisc.252b7130.png";